"use strict";

Shopify.theme.jsFaqBlock = {
  init: function init($section) {
    let $panel = $section.find('.faq__item')
 	$panel.on('click',function(){
        if($(this).find('.faq__item-answer').css('display')=='none'){
            $(this).find('.faq__item-panel').addClass('tab--open')
            $(this).find('.faq__item-answer').slideDown()
        }else{
            $(this).find('.faq__item-answer').slideUp(()=>{
                $(this).find('.faq__item-panel').removeClass('tab--open')
            })
        }
    })
  },
  unload: function unload($section) {
    let $panel = $section.find('.faq__item')
    $panel.off('click');
  }
};